export const data = window.__INITIAL_STATE__;

export const brands = data.teamsport_brands;

export const commonText = data.common_text;

export const { currency } = data;
